export default __webpack_public_path__ + "static/media/1765.4ef2dc4f.png";